import {
  BasketIcon,
  HeartIcon,
  HouseIcon,
  TextAlignLeftIcon,
  UserIcon,
} from "@phosphor-icons/react";
import { useNavigate, useLocation } from "react-router-dom";
import settings from "./settings";

const BottomBar = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Settings'ten değerleri al
  const backgroundColor = settings.backgroundColor.value;
  const activeBackgroundColor = settings.activeBackgroundColor.value;
  const iconColor = settings.iconColor.value;
  const textColor = settings.textColor.value;
  const badgeBackgroundColor = settings.badgeBackgroundColor.value;
  const badgeTextColor = settings.badgeTextColor.value;
  const borderColor = settings.borderColor.value;
  const paddingX = settings.paddingX.value + "px";
  const iconSize = settings.iconSize.value;
  const itemSize = settings.itemSize.value + "px";
  const fontSize = settings.fontSize.value + "px";
  const activeOffset = settings.activeOffset.value + "px";
  const itemGap = settings.itemGap.value + "px";
  const borderRadius =
    settings.borderRadius.value === 9999
      ? "9999px"
      : settings.borderRadius.value + "px";
  const showLabels = settings.showLabels.value;
  const animationDuration = settings.animationDuration.value + "ms";
  const showBadge = settings.showBadge.value;
  const hiddenPaths = settings.hiddenPaths.value
    .split(",")
    .map((path) => path.trim());

  const totalQuantity = data?.cart?.itemCount ?? 0;

  const onBottomBarItemClick = (path) => {
    navigate(path);
  };

  // İkon mapping fonksiyonu
  const getIcon = (iconName) => {
    const iconProps = { width: iconSize, height: iconSize, color: iconColor };
    switch (iconName) {
      case "HouseIcon":
        return <HouseIcon {...iconProps} />;
      case "TextAlignLeftIcon":
        return <TextAlignLeftIcon {...iconProps} />;
      case "BasketIcon":
        return <BasketIcon {...iconProps} />;
      case "HeartIcon":
        return <HeartIcon {...iconProps} />;
      case "UserIcon":
        return <UserIcon {...iconProps} />;
      default:
        return <HouseIcon {...iconProps} />;
    }
  };

  const navItems = [
    {
      path: "/",
      icon: getIcon("HouseIcon"),
      label: "Anasayfa",
    },
    {
      path: "/categories",
      icon: getIcon("TextAlignLeftIcon"),
      label: "Kategoriler",
    },
    {
      path: "/cart",
      icon: getIcon("BasketIcon"),
      label: "Sepet",
    },
    {
      path: "/favorites",
      icon: getIcon("HeartIcon"),
      label: "Favorilerim",
    },
    {
      path: data?.customer?.id ? "/account" : "/welcome",
      icon: getIcon("UserIcon"),
      label: "Profil",
    },
  ];

  const isHidden = hiddenPaths.includes(location.pathname);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: paddingX,
        paddingRight: paddingX,
        backgroundColor: backgroundColor,
        zIndex: 50,
        transition: `all 500ms ease-in-out`,
        transform: isHidden ? "translateY(100%)" : "translateY(0)",
        opacity: isHidden ? 0 : 1,
        pointerEvents: isHidden ? "none" : "auto",
        paddingBottom:
          data?.system?.safeArea?.bottom / data?.system?.pixelRatio ?? 0,
        willChange: "transform, opacity",
      }}
    >
      {navItems.map((item) => {
        const isActive = location?.pathname === item.path;
        return (
          <div
            key={item.path}
            onClick={() => onBottomBarItemClick(item.path)}
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: itemGap,
              transition: `top ${animationDuration} cubic-bezier(0.4,0,0.2,1)`,
              cursor: "pointer",
              top: isActive ? `-${activeOffset}` : "0",
            }}
          >
            <div
              style={{
                border: `1px solid ${borderColor}`,
                borderRadius: borderRadius,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: itemSize,
                width: itemSize,
                transition: `colors ${animationDuration} cubic-bezier(0.4,0,0.2,1)`,
                position: "relative",
                backgroundColor: isActive
                  ? activeBackgroundColor
                  : backgroundColor,
              }}
            >
              {item.icon}
              {/* Cart quantity badge */}
              {item.path === "/cart" && totalQuantity > 0 && showBadge && (
                <div
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "-4px",
                    backgroundColor: badgeBackgroundColor,
                    color: badgeTextColor,
                    fontSize: "12px",
                    fontWeight: "bold",
                    borderRadius: "9999px",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                >
                  {totalQuantity > 99 ? "99+" : totalQuantity}
                </div>
              )}
            </div>
            {showLabels && (
              <div
                style={{
                  fontSize: fontSize,
                  fontWeight: "bold",
                  color: textColor,
                  overflow: "hidden",
                  transition: `all ${animationDuration} cubic-bezier(0.4,0,0.2,1)`,
                  opacity: isActive ? 1 : 0,
                  maxHeight: isActive ? "20px" : "0",
                }}
              >
                {item.label}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default BottomBar;
